import { FileActionType } from '../enums/FileActionType';

export class FileActionsService {
  static isPrint(type: FileActionType): boolean {
    return type === FileActionType.Print;
  }
}
